import { useEffect, useState } from 'react'
import { useOptionalCommunity } from './CommunityContext'
import { appearanceOf } from './appearance'

const isDarkNow = () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark')

/** F-191: whether the screen is in the dark theme right now (the `dark` class on <html>). */
export function useDarkTheme(): boolean {
  const [dark, setDark] = useState(isDarkNow)
  useEffect(() => {
    const observer = new MutationObserver(() => setDark(isDarkNow()))
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] })
    setDark(isDarkNow())
    return () => observer.disconnect()
  }, [])
  return dark
}

/**
 * F-191 phase 1: the community logo for the current theme. In the dark theme
 * the dark logo when the community uploaded one; otherwise the regular logo,
 * with `plate` set so the caller puts it on a light plate (a dark logo on a
 * dark background disappears).
 */
export function useCommunityLogo(): { url: string | null; plate: boolean } {
  const community = useOptionalCommunity()
  const dark = useDarkTheme()
  const logo = community?.logoUrl || null
  if (!dark) return { url: logo, plate: false }
  const darkLogo = appearanceOf(community?.appearance).darkLogoUrl
  if (darkLogo) return { url: darkLogo, plate: false }
  return { url: logo, plate: Boolean(logo) }
}
